'use client'

import { Archive } from 'lucide-react'

export function ArchiveStatusBanner() {
  return (
    <div className="nb-archive-status" role="status" aria-live="polite">
      <div className="nb-archive-status__icon" aria-hidden>
        <Archive size={14} strokeWidth={2} />
      </div>
      <div className="nb-archive-status__copy">
        <span className="nb-archive-status__title">Archived notebook</span>
        <span className="nb-archive-status__hint">
          View only — unarchive from the menu to edit again.
        </span>
      </div>
    </div>
  )
}
